const state = {
    orden_compra: null,
}
// --------------------------------------------------------------------------------
const actions = {
    _setOrdenCompra: (store, orden_compra) => {
        localStorage.setItem("orden_compra", JSON.stringify(orden_compra))
        store.commit("_setOrdenCompra", orden_compra)
    },
    _getOrdenCompra: (store) => {
        store.commit("_setOrdenCompra",
            localStorage.getItem("orden_compra")
                ? JSON.parse(localStorage.getItem("orden_compra"))
                : null
        )
    },
}
// --------------------------------------------------------------------------------
const mutations = {
    _setOrdenCompra: (state, orden_compra) => {
        state.orden_compra = orden_compra
    },
}
// --------------------------------------------------------------------------------
const getters = {
    _ordenCompra: state => state.orden_compra,
}
// --------------------------------------------------------------------------------
export const OrdenStore = {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
}